import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useModuleByIdQuery } from '@entities/Module';
import { ModulePreview } from '@features/ModulePreview';

export default function ModulePreviewPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { data: module, isLoading } = useModuleByIdQuery(id ?? null);

  if (isLoading) {
    return (
      <div className="lx-prev-wrap">
        <div className="relative z-[2] flex min-h-[100dvh] items-center justify-center text-[14px] text-muted">
          {t('preview.loading')}
        </div>
      </div>
    );
  }

  if (!module) {
    return (
      <div className="lx-prev-wrap">
        <div className="relative z-[2] flex min-h-[100dvh] items-center justify-center text-[14px] text-muted">
          {t('moduleDetail.notFound')}
        </div>
      </div>
    );
  }

  return <ModulePreview module={module} />;
}
